import { observable, transaction, map, computed, when, reaction, runInAction, action, toJS, autorun } from 'mobx';
import ProductApi from './api';
import { platform } from 'mutants-util';
import { registerLogoutMiddleWare } from 'tplus-api';
import { localStore } from 'mutants-microfx';
import { PosInitData } from 'tplus-poslogin';

registerLogoutMiddleWare('product',()=>{
  console.log('执行注销后的清理动作 =>  清空商品等级');
  localStore.set('productLevel', '');
  localStore.set('product-keyboard', '');
  localStore.set('ByProduct', '');
  localStore.set('ByMember', '');
});
export default class ProductStore {

  constructor() {
    this.posCode = PosInitData && PosInitData('posCode');
    let localStoreData = localStore.get('setting_setData');
    let item = localStoreData && localStoreData.find((value) => {
      return value.Name === 'RE_POSProductPageStyle'
    })
    this.POSProductPageStyle = (item && item.Value === '56831' ? false : true);
  }

  @action init(configure) {
    this.getProductList('init');
    this.getProductLevel(configure);
  }
  @observable level_1 = '-1';
  @observable level_2 = '';
  @observable productLevel = [];
  @observable productList = [];
  @observable backupsProductList = [];
  @observable params = {
    Key: '', // 存货条码录入框输入的值，可以是助记码、存货编码，也可以是条形码
    SearchType: 0, // “0”不指定，1：“条形码” 2：“非条形码”
    IdinventoryClass: -1, // 存货分类Id，-1代表常用分类，-2代表全部分类，其他以数据库的为准
    PageNo: 1, // 当前页号 从1开始
    PageSize: 20,  // 每页大小
    isReturn: false,
    IsSelfCash:platform.isVerticalTouch,//是否是自助收银
    Idmember: '', //会员ID
    Idstore:''    // 门店ID
  }
  @observable pageCount = 0;
  @observable dataLoading = false;
  @observable showPageCount = 0;
  @observable pageTotalCount = 0;

  justOneResultCallBack = () => { };

  setLocalStorage(key, value) {
    localStore.set(key, value);
  }

  getLocalStorage(key) {
    return localStore.get(key);
  }

  @action getCurrentProductList(count) {
    this.pageTotalCount = Math.ceil(this.backupsProductList.length / this.showPageCount);
    // console.log(this.backupsProductList.length, this.showPageCount, this.pageTotalCount, 'pageTotalCount-------------------')
    // console.log(count * this.showPageCount, this.showPageCount * (count + 1), 'showPageCount-------------------');
    this.productList = this.backupsProductList.slice(count * this.showPageCount, this.showPageCount * (count + 1));
    console.log(this.productList, count * this.showPageCount, this.showPageCount * (count + 1), '=====')
  }

  @action setShowPageCount(showPageCount) {
    this.showPageCount = showPageCount;
  }

  @action async getProductLevel(configure) {
    let productLevel = this.getLocalStorage('productLevel');
    let Re_InventoryClass = this.getLocalStorage('Re_InventoryClass');
    let InventoryClassNotDisplay = this.getLocalStorage('InventoryClassNotDisplay');
    let InventoryClassOnlyDisplay = this.getLocalStorage('InventoryClassOnlyDisplay');
    if (productLevel && productLevel.length > 0
      && Re_InventoryClass && Re_InventoryClass == configure.Re_InventoryClass
      && InventoryClassNotDisplay == configure.InventoryClassNotDisplay
      && InventoryClassOnlyDisplay == configure.InventoryClassOnlyDisplay
    ) {
      this.setProductLevel(productLevel);
    } else {
      const Data = await ProductApi.loadInventoryClass(configure.idStore, this.posCode);
      this.setProductLevel(Data);
      this.setLocalStorage("productLevel", this.productLevel);
      this.setLocalStorage("InventoryClassNotDisplay", configure.InventoryClassNotDisplay);
      this.setLocalStorage("InventoryClassOnlyDisplay", configure.InventoryClassOnlyDisplay);
      this.setLocalStorage("Re_InventoryClass", configure.Re_InventoryClass);
    }
    return toJS(this.productLevel);
  }

  @action setProductLevel(value) {
    this.productLevel = value;
  }

  @action setParams(type, value) {
    this.params[type] = value;
  }

  @action retrunFirsterLevel(ID) {
    this.level_1 = '-1';
    this.level_2 = '';
    this.changeParams('ID');
  }

  @action changeFirshLevel(ID) {
    this.level_1 = ID;
    let level1 = this.productLevel.filter(v => v.ID === ID)[0];
    this.level_2 = level1 && level1.ChildClass && level1.ChildClass.length > 0 ? level1.ChildClass[0].ID : '';
    this.changeParams('ID');
  }

  @action changeSecondLevel(ID) {
    this.level_2 = ID;
    this.changeParams('ID');
  }

  @action getParams(type) {
    return this.params[type];
  }

  @action changeParams(type, value) {
    if (type === 'key') { // 搜索关键字
      this.level_1 = -2;
      this.level_2 = '';
      this.params = {
        ...this.params, Key: value,
        SearchType: 0,
        IdinventoryClass: -2, // 关键字搜索的时候，存货分类变成 全部
        PageNo: 1,
        PageSize: this.params.PageSize
      }
    } else if (type === 'ID') { // 按级别搜索
      this.params = {
        ...this.params,
        Key: '',
        SearchType: 0,
        IdinventoryClass: this.level_2 || this.level_1,
        PageNo: 1,
        PageSize: this.params.PageSize
      }
    }
  }

  @action reset() {

  }
  @action resetParams() {
    this.params = {
      Key: '', // 存货条码录入框输入的值，可以是助记码、存货编码，也可以是条形码
      SearchType: 0, // “0”不指定，1：“条形码” 2：“非条形码”
      IdinventoryClass: -2, // 存货分类Id，-1代表常用分类，-2代表全部分类，其他以数据库的为准
      PageNo: 1, // 当前页号 从1开始
      PageSize: this.params.PageSize,  // 每页大小
      isReturn: this.params.isReturn,
      IsSelfCash: platform.isVerticalTouch
    }
  }

  getProductList(isInit) {
    autorun(async () => {
      console.log(this.params);
      this.dataLoading = true;
      // try {
        let { RetailDetailData, InventoryData, TotalCount, IsBarCode } = await ProductApi.searchInventory({ ...this.params, posCode: this.posCode });
        this.dataLoading = false;
      // } catch (e) {
      //   console.log(e);
      //   this.dataLoading = false;
      // }
      if (isInit && TotalCount == 0) {
        this.changeFirshLevel(-2);
        isInit = null;
        return;
      }
      isInit = null;
      console.log(TotalCount);
      console.log('InventoryData===========', InventoryData);
      if (!InventoryData && this.params.Key) {
        // 重置状态
        this.resetParams();
        this.reset();
        return;
      }
      // if (TotalCount == 1 && IsBarCode && this.params.PageNo == 1 && RetailDetailData) {
      //   this.justOneResultCallBack && this.justOneResultCallBack(RetailDetailData);
      //   this.resetParams();
      // }
      if (this.params.Key && this.params.PageNo == 1 && InventoryData.length == 0) { // 关键字查找 查不到数据
        // 重置状态
        // this.resetParams();
        // this.reset();
        // return;
      }
      this.setProductList(InventoryData);
      this.setTotalCount(Math.ceil(TotalCount / this.params.PageSize));
    })
  }

  @action setTotalCount(value) {
    this.pageCount = value;
  }

  @action async getMoreProductList() {
    if (this.pageCount > this.params.PageNo) {
      this.params = {
        Key: this.params.Key,
        SearchType: this.params.SearchType,
        IdinventoryClass: this.params.IdinventoryClass,
        PageNo: +this.params.PageNo + 1,
        PageSize: this.params.PageSize,
        Idstore:this.params.Idstore
      }
    }
  }

  @action setProductList(Data) {
    if (this.params.PageNo != 1) {
      this.productList = this.productList.concat(Data);
    } else {
      this.productList = [];
      setTimeout(() => {
        this.set(Data);
      })
    }
  }

  @action set(data) {
    this.backupsProductList = this.productList = data;
    !this.POSProductPageStyle && this.getCurrentProductList(0)
  }

  @computed get getSecondLevelChildClass() {
    let level1 = this.productLevel.filter(item => item.ID == this.level_1)[0];
    if (level1 && level1.ChildClass && level1.ChildClass.length > 0) {
      return toJS(level1.ChildClass);
    }
    return undefined;
  }

  @computed get getToJsProductList() {
    return toJS(this.productList);
  }
}
